module.exports = __webpack_public_path__ + "static/media/Mar_2026_5.951a1e42.webp";